<template>
  <div class="footer">
    <div class="fcontent">
      <div>
          <p>联系电话</p>
          <p class="phone"><img src="../../assets/telphone.png" alt=""></p>
          <p><!-- 周一至周五9:00-18:00(仅收市话费)  -->
            <router-link to="/introduce?m=2&c=3"><span class="contact">联系我们</span></router-link>
          </p>
      </div>
      <div class="code"><img src="../../assets/code.png" alt=""></div> 
    </div>
    <div class="footer1">
      Copyright © 合肥高创股份有限公司 皖ICP备05121185号&nbsp;&nbsp;&nbsp;&nbsp;技术支持:<a href="http://www.joyimedia.com/">安徽英弗伦斯科技有限公司</a>
    </div>
  </div>
</template>

<script>
export default {
  name:'vuefooter',
  data (){
    return {

    }
  }
}
</script>

<style scoped>
  .footer{background:#333;width:100%;min-width: 1200px;position:relative;}
  .footer .fcontent{width:1200px;margin:0 auto;color:#fff;padding:10px 0px;} 
  .footer .fcontent p{margin:5px 0px;}
  .footer .fcontent p:nth-child(1){font-size:14px;}
  .footer .fcontent p:nth-child(2){font-size:38px;}
  .footer .fcontent p:nth-child(3){font-size:12px;}
  .footer .footer1{text-align:center;font-size:12px;color:#afafaf;height:29px;line-height: 29px;
  background:#000;}
  .footer .footer1 a{color:#afafaf;}
  .pagination-block{ position:absolute;right:0px; bottom: 10px;}
  .phone{height:45px;width:250px;padding:8px 0px;}
  .phone img{width:90%;}
  .contact{background:#e60012;color:#fff;display: inline-block;padding:5px 10px;border-radius: 2px;}
</style>


// WEBPACK FOOTER //
// src/components/party/VueFooter.vue